import React from 'react';
import { Collapse } from 'react-bootstrap';
import CheckboxInput from 'shared/components/CheckboxInput';
import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';
import CounterboreHoles from 'shared/components/parameters/CounterboreHoles';
import CounterboreSlots from 'shared/components/parameters/CounterboreSlots';

const Counterbore = (props) => {
  const name = 'counterbores';

  const {
    parameters,
    onChangeParameter,
    groupName,
    label,
    tooltip,
    showCollapse
  } = props;

  const onChange = e => onChangeParameter(name, e.target.checked ? '1' : '0');

  const checked = parameters && parameters[name] === '1';

  return (
    <div>
      <CheckboxInput
        inputId={name}
        inputClassName="mr-2"
        name={name}
        groupName={groupName}
        checked={checked}
        onChange={onChange} />
      <Label htmlFor={name} label={label}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>

      <Collapse in={showCollapse && checked}>
        <div className="row">
          <div className="col-12">
            <CounterboreHoles {...props} />
          </div>
          <div className="col-12">
            <CounterboreSlots {...props} />
          </div>
        </div>
      </Collapse>
    </div>
  );
};

Counterbore.defaultProps = {
  label: Spree.translations.parameters.counterbores,
  tooltip: Spree.helpForParameters.counterbores,
  showCollapse: true
};

export default Counterbore;
